"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TableauSheetEvent {
    constructor(type, sheet) {
        this._sheet = sheet;
    }
    get sheet() {
        return this._sheet;
    }
}
exports.TableauSheetEvent = TableauSheetEvent;
//# sourceMappingURL=TableauSheetEvent.js.map